import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { TiposMaterialDTO } from "src/app/models/tipo-material.dto";
import { TipoMaterialesService } from "../tipos-materiales.service";
import { CrudWImageForm } from "src/app/components/shared/cruds/crud-w-image.form";
import { NgxImageCompressService } from "ngx-image-compress";

@Component({
  selector: "app-form-tipo-material",
  templateUrl: "./form.component.html",
})
export class TipoMaterialForm extends CrudWImageForm<TiposMaterialDTO> {
  constructor(
    public fb: FormBuilder,
    private service: TipoMaterialesService,
    private compress: NgxImageCompressService
  ) {
    super(fb, compress);
  }

  // TODO add validators
  public buildForm() {
    this.form = this.fb.group({
      IdTipoMaterial: [""],
      Descripcion: [""],
    });
  }
  public fromInit(row: TiposMaterialDTO) {
    this.form.controls["IdTipoMaterial"].setValue(
      this.defaults?.IdTipoMaterial
    );
    this.form.controls["Descripcion"].patchValue(this.defaults?.Descripcion);
  }

  public loadImage() {
    this.service.image(this.defaults.IdTipoMaterial).subscribe(
      (str) => (this.valueImg = str),
      (err) => (this.valueImg = this.imgDef)
    );
  }
}
